import axios from 'axios';
import backendAxios from '../utils/backendAxios';

import { USERS_ERROR, GET_USER, GET_USERS, CLEAR_USER, TOGGLE_FAVORITE, LOGOUT_CLIENT } from './types';
import { URL } from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

/***************RECUPERAR CONTRASEÑA******************/

export const checkUser = async dato => {
  try {
    const res = await axios.get(`${URL}/api/users/telemail/${dato}`,);
    return res.data;
  } catch (err) {
    console.error(err, "Error en checkUser");
    return false;
  }
}

//Obtener código por SMS o por Email (2025)
export const getCode = async (emailTel, data) => {
  try {
    if (emailTel === "celular") {
      const res = await axios.get(`${URL}/api/users/phone?phonenumber=${data.tel}&channel=sms&forgotpass=true`);
      return res.data;
    } else {
      const res = await axios.post(`${URL}/api/users/send/email`, data);
      return res.data;
    }

  } catch (err) {
    console.error(err, "Error al enviar el código (getCode)");
    return false;
  }
}

//Revisar código por SMS (2025)
export const checkCode = async (formData, addUser = false) => {
  try {
    const res = await axios.get(`${URL}/api/users/verify?phonenumber=${formData.phonenumber}&code=${formData.code}`);
    if (addUser) {
      return res.data
    }
    if (res.data.status === 'approved' && res.data.valid === true) {
      return true
    }
  } catch (err) {
    console.error(err, "Error al verificar el código (checkCode)");
    return false;
  }
}

// Recuperar contraseña, paso 2: el SERVIDOR comprueba el código (correo o SMS) y entrega un permiso de un solo uso para poner la contraseña
// nueva. canal: 'email' | 'celular'; dato: el correo o el teléfono con lada. Devuelve { token }, { error } o { legado: true } cuando el servidor
// es el anterior (no tiene esta ruta): entonces el código se sigue comprobando aquí, como antes.
export const verificarCodigoRecuperacion = async ({ canal, dato, codigo }) => {
  try {
    const res = await axios.post(`${URL}/api/users/password/verificar`, { canal, dato, codigo }, config);
    return { token: res.data.token };
  } catch (err) {
    if (err.response && err.response.status === 404) return { legado: true };
    console.error(err, "Error al verificar el código (verificarCodigoRecuperacion)");
    if (!err.response) return { error: 'No se pudo verificar el código. Revisa tu conexión.' };
    return { error: err.response.data?.msg || err.response.data?.errors?.[0]?.msg || 'Código incorrecto' };
  }
}

// Cambiar password en olvidar contraseña (2025). formData: { password, token } (el token es el permiso de verificarCodigoRecuperacion)
export const changePassForgot = async (formData, id) => {
  try {
    await axios.patch(`${URL}/api/users/client/pass/forgot/${id}`, formData, config);
    return true;
  } catch (err) {
    console.error(err, "Error al cambiar la contraseña (changePassForgot)");
    return false;
  }
}

// Crear cuenta o cambiar el correo / el celular: el SERVIDOR comprueba el código y entrega un permiso de un solo uso para guardar ESE dato.
// canal: 'email' | 'celular'; dato: el correo o el teléfono con lada. Devuelve { permiso }, { error } o { legado: true } cuando el servidor
// es el anterior (no tiene esta ruta): entonces el código se sigue comprobando aquí, como antes.
export const verificarCodigoContacto = async ({ canal, dato, codigo }) => {
  try {
    const res = await axios.post(`${URL}/api/users/contacto/verificar`, { canal, dato, codigo }, config);
    return { permiso: res.data.permiso };
  } catch (err) {
    if (err.response && err.response.status === 404) return { legado: true };
    console.error(err, "Error al verificar el código (verificarCodigoContacto)");
    if (!err.response) return { error: 'No se pudo verificar el código. Revisa tu conexión.' };
    return { error: err.response.data?.msg || err.response.data?.errors?.[0]?.msg || 'Código incorrecto' };
  }
}

// Mensaje de error que manda el servidor (express-validator o { msg })
const motivoDe = (err, porDefecto) => err?.response?.data?.errors?.[0]?.msg || err?.response?.data?.msg || porDefecto;

//Enviar código por SMS en Crear Cuenta(SMS 2025)
export const sendCode = async (infoUser, aDonde, history) => {
  try {
    const res = await axios.get(`${URL}/api/users/phone?phonenumber=${infoUser.num}&channel=sms`);
    if (aDonde !== '') {
      history(aDonde, {
        state: {
          to: res.data.to,
          infoUser,
          emailTel: "celular"
        }
      });
    }
  } catch (err) {
    console.error(err, "Error al enviar el código (sendCode)");
    return false;
  }
}

//Enviar código por email (2025)
export const sendCodeEmail = async data => {
  try {
    const res = await axios.post(`${URL}/api/users/send/email`, data);
    return res;

  } catch (err) {
    console.error(err, "Error al enviar el email (sendCodeEmail)");
    return false;
  }
}


/****************REGISTRO****************/

//Verificar email (2025)
export const checkEmail = async email => {
  try {
    await axios.get(`${URL}/api/users/email/${email}`);
    return true;
  } catch (err) {
    console.error(err, "Error en checkEmail");
  }
}

// Agregar usuario en crear cuenta (2025). formData lleva el `permiso` de verificarCodigoContacto (correo) o de checkCode (SMS).
// Devuelve { ok: true, celularSinConfirmar } o { ok: false, error } con el motivo del servidor. No lleva a ningún lado: Step3 inicia
// la sesión y luego va a la última pantalla.
export const addUser = async (formData) => {
  try {
    const res = await axios.post(`${URL}/api/users/client`, formData, config);
    return {
      ok: true,
      // Con el código del correo el celular queda sin confirmar (lo dice el servidor; el anterior no lo manda): la última pantalla lo avisa
      celularSinConfirmar: Boolean(formData.tel) && res?.data?.telVerificado === false,
    };
  } catch (err) {
    console.error("Error en addUser(actions)");
    return { ok: false, error: motivoDe(err, 'No se pudo crear la cuenta. Inténtalo de nuevo.') };
  }
}

// Obtener usuario por el ID (2025)
export const getUserbyId = async id => {
  try {
    const res = await backendAxios.get(`/api/users/client/${id}`);
    return res.data;
  } catch (err) {
    console.error(err, "Error al obtener el usuario");
  }
}


/***********************PERFIL***********************/

// Nota: la verificación (RFC/CURP/documentos) se maneja directo en
// components/user/tabs/Documentos.js contra /api/users/client/verificacion/*

// Get user
export const getUser = id => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/users/client/${id}`);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

// Edita el avatar del usuario (2025)
export const editAvatar = image => async dispatch => {
  try {
    dispatch(uploadAvatar(image));
  } catch (err) {
    console.error("Error en editAvatar actions", err);
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Edita el nombre y el apellido, fecha de nacimiento y sexo del usuario (2025)
export const editDatosPersonales = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/edit/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Errors");
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Edita si se comparte la info del usuario (2025)
export const editShare = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/share/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.error(err, 'Error al editShare');
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Editar email del usuario (2025). formData: { email, permiso } (el permiso de verificarCodigoContacto para ESE correo).
// Devuelve { ok: true } o { ok: false, error } con el motivo del servidor (correo de otra cuenta, falta confirmar el código…).
export const editEmail = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/email/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
    return { ok: true };
  } catch (err) {
    console.log("Error en editEmail", err);
    dispatch({
      type: USERS_ERROR
    });
    return { ok: false, error: motivoDe(err, 'No se pudo guardar el correo. Inténtalo de nuevo.') };
  }
}

// Cambiar (o crear, en una cuenta de Google o Facebook) la contraseña del usuario logueado: { passwordActual, password }.
// Devuelve { ok: true } o { ok: false, msg, campo, codigo } con el motivo del servidor (contraseña actual equivocada, demasiados
// intentos, hay que volver a entrar…). El token nuevo que manda el servidor lo guarda solo backendAxios (x-token-refresh).
export const changePass = async (formData) => {
  try {
    await backendAxios.patch(`/api/users/client/pass`, formData);
    return { ok: true };
  } catch (err) {
    const data = err.response?.data || {};
    const primero = Array.isArray(data.errors) ? data.errors[0] : null;
    return {
      ok: false,
      msg: primero?.msg || data.msg || 'No se pudo guardar la contraseña. Inténtalo de nuevo.',
      campo: primero?.param || primero?.path || '',
      codigo: data.codigo || '',
    };
  }
}

// Manda el SMS para cambiar el celular del perfil (tel = 10 dígitos; el servidor no lo manda a un celular que ya es de otra cuenta).
// Devuelve { ok: true } o { ok: false, error }.
export const sendCodeTelefono = async (tel) => {
  try {
    await axios.get(`${URL}/api/users/phone?phonenumber=52${tel}&channel=sms`);
    return { ok: true };
  } catch (err) {
    console.error(err, "Error al enviar el código (sendCodeTelefono)");
    return { ok: false, error: motivoDe(err, 'No se pudo enviar el código a ese celular') };
  }
}

//Verifica el numero de celular del usuario y lo guarda en la base datos (2025). formData: { tel (10 dígitos), code }.
// El servidor comprueba el código con Twilio y entrega el permiso que pide PATCH /client/phone. Devuelve { ok: true } o { ok: false, error }.
export const verifySavePhone = (formData, id) => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/users/verify?phonenumber=52${formData.tel}&code=${formData.code}`);
    if (res.data.status === 'approved' && res.data.valid === true) {
      const result = await backendAxios.patch(`/api/users/client/phone/${id}`, { tel: formData.tel, permiso: res.data.permiso });
      dispatch({
        type: GET_USER,
        payload: result.data
      });
      return { ok: true };
    }
    return { ok: false, error: 'Código incorrecto. Por favor, intenta de nuevo.' };
  } catch (err) {
    console.error(err, "Error al verificar y guardar el teléfono (verifySavePhone)", err);
    dispatch({
      type: USERS_ERROR,
    });
    return { ok: false, error: motivoDe(err, 'No se pudo guardar el celular. Inténtalo de nuevo.') };
  }
}

// Upload del avatar y guarda la version en la BD (2025)
export const uploadAvatar = formData => async dispatch => {
  try {
    formData.append("usuario", true);
    // backendAxios (no axios puro) para que viaje el x-auth-token: el endpoint /upload
    // ahora exige sesión. El Content-Type multipart explícito evita que axios convierta
    // el FormData a JSON (comportamiento por el default application/json de backendAxios).
    const res = await backendAxios.post(`/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    const arr = res.data.public_id.split('/');
    const info = {
      version: res.data.version,
      // Nombre del archivo subido (= user._id, con el que se guarda en Cloudinary).
      // Antes se mandaba 'ava', que el backend interpretaba como "no cambiar el avatar",
      // por lo que user.avatar se quedaba con la URL de gravatar y la foto nunca se veía.
      avatar: arr[arr.length - 1]
    }

    const response = await backendAxios.patch(`/api/users/client/avatar/${arr[1]}`, info);
    dispatch({
      type: GET_USER,
      payload: response.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: err.response.data.msg
    });
  }
}

// Search users
export const searchUsers = busqueda => async dispatch => {
  try {
    const res = await backendAxios.get(`/api/users/client/search/${busqueda}`);
    dispatch({
      type: GET_USERS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: { msg: err.response?.statusText || "Server Error", status: err.response?.status || 500 }
    });
  }
}

// Buscar personas por nombre, apellido o correo (mínimo 3 letras) sin pasar por Redux: cada buscador guarda sus resultados.
// Sirve para elegir a quien imparte un servicio de una página.
export const buscarPersonas = async (busqueda) => {
  const texto = String(busqueda || '').trim();
  if (texto.length < 3) return [];
  try {
    const res = await backendAxios.get(`/api/users/client/search/${encodeURIComponent(texto)}`);
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    return [];
  }
};

//Clear user profile
export const clearUser = () => async dispatch => {
  try {
    dispatch({
      type: CLEAR_USER,
    });
  } catch (err) {
    console.error(err);
  }
}
// Favoritos (2025)
export const toggleFavorite = (serviceId) => async dispatch => {
  try {
    const res = await backendAxios.post(`/api/users/favorite/${serviceId}`);
    dispatch({
      type: TOGGLE_FAVORITE,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Error al toggleFavorite");
    dispatch({
      type: USERS_ERROR,
      payload: { msg: "Error al agregar a favoritos", status: 500 }
    });
  }
}

// Eliminar cuenta de usuario (Borrado Híbrido)
export const deleteAccount = (history) => async dispatch => {
  try {
    await backendAxios.delete(`/api/users/`);
    dispatch({ type: CLEAR_USER });
    dispatch({ type: LOGOUT_CLIENT });
    history('/');
  } catch (err) {
    console.error(err, "Error al eliminar cuenta");
    dispatch({
      type: USERS_ERROR,
      payload: { msg: "Error al eliminar cuenta", status: 500 }
    });
  }
}
